import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  onClose: () => void
  companyId: number
  id: number
  onSuccess: () => void
}

export const RemoveProductDataModal: FC<Props> = ({ onClose, companyId, id, onSuccess }) => {
  const { t } = useTranslation(['user'])

  const [progress, remove] = useAProgress(
    () => apiClient.delete(endpoints.companyProductData(companyId.toString(), id.toString())),
    {
      eventName: 'removeProductData',
      onSuccess,
    },
  )

  return (
    <ResponsiveModal
      id="removeProductDataModal"
      onClose={onClose}
      title={t('removeProductData')}
      onConfirm={remove}
      confirmButtonText={t('common:yes_remove')}
      progress={progress}
      size="small"
    >
      <SharedModalContent>{t('removeProductData')}</SharedModalContent>
    </ResponsiveModal>
  )
}
